export interface PersonalInfo {
  fullName?: string;
  firstName?: string;
  lastName?: string;
  civility?: "" | "M." | "Mme.";
  title: string;
  email: string;
  phone: string;
  location: string;
  city?: string;
  country?: string;
  birthDate?: string;
  website?: string;
  summary: string;
  avatar?: string;
  nationality?: string;
  birthPlace?: string;
  gender?: string;
  maritalStatus?: string;
}

export interface Experience {
  company: string;
  position: string;
  startDate: string;
  endDate: string;
  description: string;
}

export interface Education {
  school: string;
  degree: string;
  date: string;
  startDate?: string;
  endDate?: string;
}

export interface CVData {
  personalInfo: PersonalInfo;
  experience: Experience[];
  education: Education[];
  skills: string[];
  languages: string[];
  hobbies: string[];
}

export interface Template {
  id: string;
  name: string;
  data: CVData;
}

export interface TemplateMap {
  [key: string]: Template;
}

export type LayoutTemplate = "ats" | "moderne" | "classique" | "pro";

export interface CVVersion {
  id: string;
  name: string;
  data: CVData;
  template: LayoutTemplate;
  createdAt: string;
  updatedAt: string;
}

export const defaultCV: CVData = {
  personalInfo: {
    firstName: "Prénom",
    lastName: "N.",
    civility: "" as const,
    title: "Titre du poste visé",
    email: "email@exemple.com",
    phone: "06 00 00 00 00",
    location: "Ville, France",
    city: "Ville",
    country: "France",
    birthDate: "",
    summary: "Résumé professionnel en quelques lignes.",
    avatar: "",
  },
  experience: [
    {
      company: "Entreprise",
      position: "Poste occupé",
      startDate: "Mois Année",
      endDate: "Mois Année",
      description: "• Mission 1\n• Mission 2",
    },
  ],
  education: [
    {
      school: "Établissement",
      degree: "Diplôme ou formation",
      date: "Année",
    },
  ],
  skills: ["Compétence 1", "Compétence 2"],
  languages: ["Français (Natif)"],
  hobbies: [],
};
